/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Audio_DeletedInputs */

const en_dialog_audio_deleted = /** @type {(inputs: Dialog_Audio_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document was deleted successfully`)
};

const es_dialog_audio_deleted = /** @type {(inputs: Dialog_Audio_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El documento fue eliminado exitosamente`)
};

/**
* | output |
* | --- |
* | "Document was deleted successfully" |
*
* @param {Dialog_Audio_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_audio_deleted = /** @type {((inputs?: Dialog_Audio_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Audio_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_audio_deleted(inputs)
	return en_dialog_audio_deleted(inputs)
});